module.exports = __webpack_public_path__ + "static/media/us.7ebe9f38.svg";